<template>
    <div v-if="logoHistory.length > 0" class="img-carousel-wrap">
        <b-carousel
            v-model="slide"
            :interval="0"
            :controls="logoHistory.length > 1"
            style="text-shadow: 1px 1px 2px #333;"
            @sliding-end="onSlideEnd"
            @sliding-start="onSlideStart"
            class="img-carousel">
            <b-carousel-slide v-for="logoObj in logoHistory" :key="logoObj.id">
                <template #img>
                    <span v-if="!isPremium" class="disabled-logo-message">{{$gettext('PREVIEW')}}</span>
                    <img v-show="showNextImage" class="logo-img image-dimension" :src="logoObj.image" :alt="$gettext('AI Generated Logo')" width="1024" height="1024">
                    <img v-show="!showNextImage" class="logo-img" :src="logoUrl" :alt="$gettext('AI Generated Logo')" width="1024" height="1024">
                </template>
            </b-carousel-slide>
        </b-carousel>
    </div>
</template>

<script>
import { mapGetters } from 'vuex'

export default {
    props: {
        logoHistory: {
            type: Array,
            default: () => []
        },
        tempLogoUrl: {
            type: String,
            default: null
        }
    },
    computed: {
        ...mapGetters({
            isPremium: 'getIsPremium'
        })
    },
    watch: {
        tempLogoUrl(newValue) {
            if (newValue) this.logoUrl = newValue
            else this.logoUrl = this.logoHistory[this.slide].image
        },
        
    },
    data() {
        return {
            slide: 0,
            logoUrl: null,
            showNextImage: false
        }
    },
    created() {
        if (this.logoHistory.length)
            this.logoUrl = this.logoHistory[this.slide].image
    },
    methods: {
        onSlideStart() {
            this.showNextImage = true
        },
        onSlideEnd () {
            this.showNextImage = false
            this.$emit('slideChanged', this.slide)
        },
        updateSlide(newVal) {
            if (newVal) this.slide = newVal
            this.logoUrl = this.logoHistory[this.slide].image
            this.$emit('slideChanged', newVal)
        }
    }
}
</script>

<style lang="scss" scoped>
.img-carousel-wrap {
  height: 100%;
  width: 100%;
  min-height: 600px;
  max-height: 600px;
  overflow: hidden;
  display: flex;
  flex-direction: column;
  align-items: center;
  .logo-img {
    height: 100%;
    width: 100%;
    object-fit: contain;
  }
}

.disabled-logo-message {
    font-size: 32px;
    font-weight: bold;
    color: #a3a3a3;
    position: absolute;
    margin-left: 37%;
    margin-top: 45%;
}
</style>

<style lang="scss">
.img-carousel {
    width: 100%;
    height: 100%;
    .carousel-control-prev-icon,
    .carousel-control-next-icon {
        background-color: $colorBrand !important;
        padding: 1rem !important;
        border-radius: 50% !important;
        border: solid $colorBrand 0.5rem !important;
    }
}
</style>